import React from 'react';
import enhance from './enhance';
import styles from './styles.module.scss';

const FunctionalGroup = ({ id, description, upcharge }) => (
  id ? <li key={id} className={styles.optionCluster}>
    <span className={styles.codeHeader}>{id}</span>
    {description} (${upcharge})
  </li> : null
)

export default enhance(FunctionalGroup);
